import React from "react";
import { useTheme } from "../context/ThemeContext";

// Логотип: в светлой кремовой теме используем тёмно-коричневый вариант,
// в классической чёрной — золотой с прозрачным фоном.
const LOGO_GOLD = "/logo-transparent.png";
const LOGO_DARK = "/logo-dark.png";

export default function Logo({ size = "md", variant = "dark", showTagline = false, glow = true }) {
  const { theme } = useTheme();
  const light = theme === "light";
  const sizes = {
    xs: { h: 24 },
    sm: { h: 40 },
    md: { h: 64 },
    lg: { h: 104 },
    xl: { h: 150 },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div data-testid="brand-logo" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img
        src={light ? LOGO_DARK : LOGO_GOLD}
        alt="Angiolini"
        style={{
          height: `${s.h}px`,
          width: "auto",
          objectFit: "contain",
          filter: light
            ? "none"
            : (variant === "light"
              ? "brightness(0.85) contrast(1.1)"
              : (glow
                ? "drop-shadow(0 0 18px rgba(197,160,89,0.55)) drop-shadow(0 0 4px rgba(212,184,120,0.45))"
                : "drop-shadow(0 2px 10px rgba(0,0,0,0.4))")),
        }}
      />
      {showTagline && (
        <div style={{
          fontFamily: "Manrope",
          fontSize: "10px",
          letterSpacing: "0.35em",
          color: light ? "rgba(74,20,16,0.6)" : "rgba(197,160,89,0.65)",
          textTransform: "uppercase",
          fontWeight: 700,
          marginTop: "6px",
        }}>
          VIP CLUB
        </div>
      )}
    </div>
  );
}
